import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-read-more-text',
  templateUrl: './read-more-text.component.html',
  styleUrls: ['./read-more-text.component.scss'],
})
export class ReadMoreTextComponent implements OnInit {
  @Input() text: any;
  @Input() maxCharacters: any;

  // public showText: any;
  // public hideText:any;
  // public textArray: any;
  // public isShowReadMoreButton: boolean;
  // public toggleButton: boolean;
  // public toggleButtonText: any;

  constructor() {}
  ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
    // if (this.text != undefined) {
    //   this.textArray = this.text.split('');
    //   if (this.textArray.length > this.maxCharacters) {
    //     this.showText = this.text.slice(0, this.maxCharacters) + '.....';
    //     this.isShowReadMoreButton = true;
    //     this.toggleButtonText = 'See more';
    //     this.toggleButton = false;
    //   } else {
    //     this.showText = this.text;
    //     this.isShowReadMoreButton = false;
    //   }
    // }
  }

  // toggleShowHide() {
  //   this.toggleButton = !this.toggleButton;
  //   if (this.toggleButton) {
  //     this.showText = this.text;
  //     this.toggleButtonText = '';
  //   } else {
  //     this.showText = this.text.slice(0, this.maxCharacters);
  //     this.toggleButtonText = 'See more';
  //   }
  // }

  ngOnInit(): void {}
}
